/** A polygon vertex as returned/accepted by the API (object form). */
export interface AgentGeoZoneLatLng {
  lat: number;
  lng: number;
}

/** Agent geo-zone status: `1` = active, `0` = inactive. */
export const AGENT_GEO_ZONE_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
} as const;

export type AgentGeoZoneStatus = (typeof AGENT_GEO_ZONE_STATUS)[keyof typeof AGENT_GEO_ZONE_STATUS];

/** List item as returned by `/agent-geo-zone/index`. */
export interface AgentGeoZoneBase {
  id: number;
  name: string;
  polygon: AgentGeoZoneLatLng[];
  status: AgentGeoZoneStatus;
  type: number;
  created_at: string;
  updated_at: string;
  children_count: number;
}

/** A child zone as part of a create/update payload. */
export interface AgentGeoZoneChildPayload {
  name: string;
  weekday: number;
  polygon: AgentGeoZoneLatLng[];
}

/** A child zone as returned by `/agent-geo-zone/show`. */
export interface AgentGeoZoneChild extends AgentGeoZoneChildPayload {
  id: number;
}

/** Full resource as returned by `/agent-geo-zone/show`. */
export interface AgentGeoZoneById extends AgentGeoZoneBase {
  children: AgentGeoZoneChild[];
}

export interface AgentGeoZoneCreatePayload {
  name: string;
  polygon: AgentGeoZoneLatLng[];
  children: AgentGeoZoneChildPayload[];
}

export interface AgentGeoZoneUpdatePayload extends AgentGeoZoneCreatePayload {
  id: number;
}

/** Item as returned by `/agent-geo-zone/polygon-list` (all saved parent zones with geometry). */
export interface AgentGeoZonePolygonListItem {
  id: number;
  name: string;
  polygon: AgentGeoZoneLatLng[];
}

/** Lightweight option used by the agent geo-zone async select. */
export interface AgentGeoZoneItem {
  id: number;
  name: string;
}

export interface AgentGeoZoneItemListParams {
  ids?: number[];
  name?: string;
}
